import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { CapturedFloorplanUploadSchema, UploadedFloorplanSchema } from '../entities/floorplans.js';
export const UploadFloorplanBodySchema = CapturedFloorplanUploadSchema;
export const UploadFloorplanHeadersSchema = ApiLambdalerAuthHeaderWithRequestActorSchema;
export const UploadFloorplanPathSchema = z.object({
    entityId: InspectionEntityCornSchema,
    inspectionId: InspectionCornSchema,
});
export const UploadFloorplanResponseSchema = UploadedFloorplanSchema;
export const UploadFloorplanApiSchema = {
    body: UploadFloorplanBodySchema,
    params: UploadFloorplanPathSchema,
    headers: UploadFloorplanHeadersSchema,
    response: UploadFloorplanResponseSchema,
};
export const UploadFloorplanRequestSchema = UploadFloorplanApiSchema.body
    .merge(UploadFloorplanApiSchema.headers)
    .merge(UploadFloorplanApiSchema.params);
